/**
 * @author    Labs64 <netlicensing@labs64.com>
 * @license   Apache-2.0
 * @link      https://netlicensing.io
 * @copyright 2017 Labs64 NetLicensing
 */
const TransactionStatus = Object.freeze({
  PENDING: 'PENDING',
  CLOSED: 'CLOSED',
  CANCELLED: 'CANCELLED',
});

export default TransactionStatus;
